<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-row class="searchSection">
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_config_' + active_name + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"> 
                </SearchForm>
            </el-row>
            <el-row class="addBtn">
                <el-button v-if="Acs('/order-contract-seal/create')" type="success" size="small" @click="showContractDialog('create')">新增合同</el-button>
                <ExportFile 
                    v-if="Acs('/export/contract-seal')"
                    url="/api/export/contract-seal" 
                    :params="searcheModel" 
                    filename="合同盖章记录表" 
                    buttonName="导出Excel">
                </ExportFile>
            </el-row>
            <el-row v-loading="loading">
                <el-table 
                v-if="!loading"
                :data="list" 
                border>
                <el-table-column prop="code" label="合同编号"></el-table-column>
                <el-table-column prop="type_str" label="合同类型"></el-table-column>
                <el-table-column prop="handle_at" label="要求处理时间"></el-table-column>
                <el-table-column prop="customer_name" label="客户名称"></el-table-column>
                <el-table-column prop="order_id" label="订单ID">
                    <template slot-scope="scope">
                        <el-button @click="handleView(scope.row)" type="text" size="small">{{scope.row.order_id}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="invoice_title" label="发票抬头"></el-table-column>
                <el-table-column prop="is_logistic_str" label="需要寄件"></el-table-column>
                <el-table-column prop="order_user_name" label="订单负责人"></el-table-column>
                <el-table-column prop="is_handle_str" label="处理状态"></el-table-column>
                <el-table-column prop="is_delete_str" label="是否作废"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="Acs('/order-contract-seal/update') && scope.row.is_delete != 1" @click="showContractDialog('update', scope.row)" type="text" size="small">编辑</el-button>
                        <el-button v-if="Acs('/order-contract-seal/delete') && scope.row.is_handle != 1 && scope.row.is_delete != 1" @click="deleteContract(scope.row)" type="text" size="small">作废</el-button>
                    </template>
                </el-table-column>
                </el-table>
                <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
            </el-row>
            <ContractSealForm :dialog_visible="dialog_visible" :params="model" :show_type="show_type" @close="closeDialog" @submit="submitForm"></ContractSealForm>
        </div>
    </div>
</template>
<script>
import OrderContractSealService from "~/services/OrderContractSeal";
import SearchForm from "~/widgets/SearchForm.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import ContractSealForm from "~/views/order/dialog/contractSealForm.vue";
export default {
    name: "ContractSeal",

    components: {
        SearchForm,
        MyPagination,
        ExportFile,
        ContractSealForm
    },

    props: {},

    data() {
        return {
            loading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
            fields: [],
            search_form_key: 0,
            active_name: 'contract-seal',
            dialog_visible: false,
            model: {},
            show_type: '',
        };
    },

    mounted() {},

    /**
     * 监听组件切换变化
     */
    watch: {
        $route(to, from) {
            this.resetForm();
        },
        multipleSelection: function (value, oldValue) {
            if (value.length > 0) {
                this.disableBatchOption = false;
            } else {
                this.disableBatchOption = true;
            }
        },
    },

    created() {
        this.resetForm();
    },

    methods: {
        //重置按钮
        resetForm() {
            this.fields = [
                {field: 'base', label: '基础信息筛选条件', children: [
                    {field: 'customer_name', label: '客户名称', type: 'components', ref: 'customer', components: 'CustomerSelect', change: 'changeObjValue'},
                    {field: 'type', label: '合同类型', type: 'select', list: OrderContractSealService.contractTypes(true)},
                    {field: 'is_handle', label: '处理状态', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '已处理'}, {value: 0, label: '未处理'}]},
                    {field: 'order_id', label: '订单ID', type: 'input'},
                    {field: 'salesman', label: '订单负责人', type: 'components', ref: 'user', components: 'UserSelect', change: 'changeObjValue'},
                    {field: 'is_logistic', label: '需要寄件', type: 'select', list: [{value: '', label: '不限'}, {value: 1, label: '是'}, {value: 0, label: '否'}]},
                ]},
                {field: 'date', label: '时间筛选条件', children: [
                    {field: 'handle_at', label: '要求处理时间', type: 'daterange'},
                ]},
            ];
            this.searcheModel = {
                active_name: this.active_name,
                user_id: this.$router.currentRoute.path == '/order/my-contract-seal' ? this.$store.getters.userId : '',
            };
            this.list = [];
            this.search_form_key ++;
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getList(params);
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            let service = null;
            if(this.$router.currentRoute.path == '/order/my-contract-seal'){
                service = OrderContractSealService.getMyIndex(params);
            }else{
                service = OrderContractSealService.getIndex(params);
            }
            service.then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },
        
        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/order/view",
                query: {id: row.order_id},
            });
            window.open(routeData.href, '_blank');
        },

        showContractDialog(type = '', row = {}){
            this.model = row;
            this.show_type = type;
            this.dialog_visible = true;
        },

        closeDialog(){
            this.model = {};
            this.dialog_visible = false;
        },

        submitForm(){
            this.closeDialog();
            this.submitSearch();
        },

        deleteContract(row){
            this.$confirm("确定作废此合同？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                OrderContractSealService.delete({ids: [row.id]}).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message:'作废成功',
                            type:'success'
                        });
                    }
                    this.submitSearch();
                })
            })
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/views/order/contractSeal.vue